<template>
  <v-main class="backgroundImage">
    <v-container class="fill-height" fluid>
      <v-card class="ma-auto" max-width="300">
        <v-card-title class="pa-6">
          <v-img class="white--text" :src="loginTitle"> </v-img
        ></v-card-title>

        <v-form
          ref="form"
          v-model="valid"
          class="pa-5"
          @keyup.enter.native="login"
          lazy-validation
        >
          <v-text-field
            v-model="service_account"
            :rules="inputRules"
            label="服務帳號"
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="user_account"
            :rules="inputRules"
            label="使用者帳號"
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="user_password"
            :rules="inputRules"
            label="密碼"
            type="password"
            autocomplete="new-password"
          ></v-text-field>

          <v-card-actions>
            <v-checkbox
              class="my-auto"
              label="記住帳號"
              v-model="remember"
              color="primary"
              hide-details
            ></v-checkbox>
            <v-btn
              class="ml-auto"
              @click="login"
              :disabled="!valid"
              :loading="loading"
              >login</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  mounted() {
    this.initUserInfo();
  },
  data: () => ({
    valid: true,
    inputRules: [(v) => !!v || "required"],
    loading: false,
    loginTitle: require("@/assets/images/PPV-Insight.png"),
  }),
  methods: {
    ...mapActions("user", ["login", "initUserInfo"]),
  },
  computed: {
    ...mapFields("user", [
      "loginData.service_account",
      "loginData.user_account",
      "loginData.user_password",
      "loginData.remember",
    ]),
  },
};
</script>

<style lang="css">
.backgroundImage {
  background: rgba(0, 0, 0, 0);
  background-image: url("../assets/images/login-bg.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
}
</style>
